import { Injectable } from '@angular/core';
import { Network } from '@capacitor/network';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class NetworkConnectivityService {

  constructor(public platform: Platform) {}

  public async isOnline(): Promise<boolean> {
    const status = await Network.getStatus();
    return status.connected;
  }

}
